<template>
    <div v-if="access.read === 1">
        <app-toolbarcustom app_title="Data Laporan" app_menu="account"></app-toolbarcustom>
        <div class="text-left ml-2" style="margin-top:70px">
            <v-progress-linear
            indeterminate
            color="fourth"
            rounded
            class="mb-2"
            v-if="loading.page"
            ></v-progress-linear>
            <v-btn
            rounded
            :color="filter.company === ''?'fourth white--text':'grey'"
            @click="List('')"
            v-if="$functions.UsersCompany() === ''"
            >
            All
            </v-btn>
            <v-btn
            rounded
            :color="filter.company === 'OPI'?'fourth white--text':'grey'"
            class="mx-2"
            @click="List('OPI')"
            v-if="$functions.UsersCompany() === '' || $functions.UsersCompany() === 'OPI'"
            >
            OPI
            </v-btn>
            <v-btn
            rounded
            :color="filter.company === 'ORI'?'fourth white--text':'grey'"
            @click="List('ORI')"
            v-if="$functions.UsersCompany() === '' || $functions.UsersCompany() === 'ORI'"
            >
            ORI
            </v-btn>
        </div>
        <v-subheader class="secondary--text">Data Karyawan Per Hari Ini: </v-subheader>
        <section class="card-scroll-header cursor" v-if="posts.employees.length > 0">
            <v-card
                class="white--text card-scroll-item"
                max-width="344"
                outlined
                v-for="(row, index) in posts.employees"
                :key="row.employee_flag"
                :color="index % 2==0 ? 'primary' : 'secondary'"
                @click="GetEmployee(row.employee_flag)"
            >
            <v-row>
                <v-col cols="12" sm="12" md="12" class="mt-2">
                <v-card-text primary-title>
                    <div>
                    <div class="heading">{{row.employee_flag}} <v-icon v-if="row.employee_icon" color="white">{{row.employee_icon}}</v-icon></div>
                    <div class="title text-xs-right mt-2">{{row.employee_flag_count}}</div>
                    </div>
                </v-card-text>
                </v-col>
            </v-row>
            </v-card>
        </section>
        <v-subheader class="secondary--text">Data Karyawan Join dan Resign </v-subheader>
        <section class="card-scroll-header cursor" v-if="posts.joinresign.length > 0">
            <v-card
                class="white--text card-scroll-item"
                max-width="344"
                outlined
                v-for="(row, index) in posts.joinresign"
                :key="row.employee_flag"
                :color="index % 2==0 ? 'primary' : 'secondary'"
                @click="GetEmployee(row.employee_flag)"
            >
            <v-row>
                <v-col cols="12" sm="12" md="12" class="mt-2">
                <v-card-text primary-title>
                    <div>
                    <div class="heading">{{row.employee_flag}} <v-icon v-if="row.employee_icon" color="white">{{row.employee_icon}}</v-icon></div>
                    <div class="title text-xs-right mt-2">{{row.employee_flag_count}}</div>
                    </div>
                </v-card-text>
                </v-col>
            </v-row>
            </v-card>
        </section>
        <v-subheader class="secondary--text font-weight-bold" @click="filter.dialog = true"><v-spacer></v-spacer>Periode: {{ this.$functions.FormatDateIndoWithDayName(filter.sdate) }} <span v-if="filter.sdate !== filter.edate"> - {{ this.$functions.FormatDateIndoWithDayName(filter.edate) }}</span> </v-subheader>
        <section class="card-scroll-header cursor">
            <v-card
                class="white--text card-scroll-item"
                max-width="344"
                outlined
                v-for="(row, index) in posts.absencetodo"
                :key="row.employee_flag"
                :color="index % 2==0 ? 'primary' : 'secondary'"
                @click="GetAbsenceTodo(row.employee_flag)"
            >
            <v-row>
                <v-col cols="12" sm="12" md="12" class="mt-2">
                <v-card-text primary-title>
                    <div>
                    <div class="heading">{{row.employee_flag}} <v-icon v-if="row.employee_icon" color="white">{{row.employee_icon}}</v-icon></div>
                    <div class="title text-xs-right mt-2" v-if="row.employee_flag !== 'LAPORAN'">{{row.employee_flag_count}}</div>
                    </div>
                </v-card-text>
                </v-col>
            </v-row>
            </v-card>
        </section>
        <v-dialog v-model="filter.dialog" max-width="490" persistent>
            <v-card>
                <v-card-title class="secondary headline white--text">{{filter.title}}</v-card-title>
                <v-card-text>
                    <v-row>
                        <!-- ID -->
                        <v-col cols="12" sm="6" md="12" class="mt-2">
                            <v-dialog
                            ref                 ="dialog_sdate"
                            v-model             ="modal.sdate"
                            :return-value.sync  ="form.sdate"
                            width               ="290px"
                            persistent
                        >
                            <template v-slot:activator="{ on }">
                            <v-text-field
                                :value              ="sdate_value"
                                label               ="Periode Awal"
                                prepend-icon  ="event"
                                background-color    ="date"
                                v-on                ="on"
                                v-mask              ="'####-##-##'"
                                placeholder         ="YYYY-MM-DD"
                                id                  ="find_sdate"
                                outlined
                            ></v-text-field>
                            </template>
                            <v-date-picker v-model="form.sdate" scrollable>
                            <v-spacer></v-spacer>
                            <v-btn text color="primary" @click="modal.sdate = false">Cancel</v-btn>
                            <v-btn
                                text
                                color   ="primary"
                                @click  ="GetData('sdate',form.sdate)"
                            >
                                OK
                            </v-btn>
                            </v-date-picker>
                        </v-dialog>
                        </v-col>
                        <!-- ID -->
                        <v-col cols="12" sm="6" md="12" class="mt-n6">
                            <v-dialog
                            ref                 ="dialog_edate"
                            v-model             ="modal.edate"
                            :return-value.sync  ="form.edate"
                            width               ="290px"
                            persistent
                        >
                            <template v-slot:activator="{ on }">
                            <v-text-field
                                :value              ="edate_value"
                                label               ="Periode Akhir"
                                prepend-icon  ="event"
                                background-color    ="date"
                                v-on                ="on"
                                v-mask              ="'####-##-##'"
                                placeholder         ="YYYY-MM-DD"
                                id                  ="find_edate"
                                outlined
                            ></v-text-field>
                            </template>
                            <v-date-picker v-model="form.edate" :min="form.sdate" scrollable>
                            <v-spacer></v-spacer>
                            <v-btn text color="primary" @click="modal.edate = false">Cancel</v-btn>
                            <v-btn
                                text
                                color   ="primary"
                                @click  ="GetData('edate',form.edate)"
                            >
                                OK
                            </v-btn>
                            </v-date-picker>
                        </v-dialog>
                        </v-col>
                    </v-row>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="secondary" outlined @click.stop="FilterDate">{{filter.close}}</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog v-model="dialog.employee" max-width="490" persistent>
            <v-card>
                <v-card-title class="secondary headline white--text">{{dialog.title}} <v-spacer></v-spacer>
                    <v-btn color="white" outlined @click.stop="dialog.employee = false">TUTUP</v-btn></v-card-title>
                    <v-subheader class="secondary--text font-weight-bold" v-if="dialog.title === 'BELUM TODO'"><v-spacer></v-spacer>{{ $functions.FormatDateIndoWithDayName(filter.sdate) }} <span v-if="filter.sdate !== filter.edate"> - {{ this.$functions.FormatDateIndoWithDayName(filter.edate) }}</span></v-subheader>
                <v-card-text class="card-text-scrollable">
                    <v-progress-linear
                    indeterminate
                    color="fourth"
                    rounded
                    class="mb-2"
                    v-if="loading.employee"
                    ></v-progress-linear>
                    <v-list-item three-line v-for="row in posts.users" :key="row.users_id">
                        <v-list-item-content>
                            <v-list-item-title>{{row.users_name}}</v-list-item-title>
                            <v-list-item-subtitle>{{row.users_title}}</v-list-item-subtitle>
                            <v-list-item-subtitle class="font-weight-bold">{{row.users_employeeid}}</v-list-item-subtitle>
                            <v-list-item-subtitle><v-btn small color="primary" @click="Balance(row.users_id)">Cek Saldo</v-btn></v-list-item-subtitle>
                        </v-list-item-content>
            
                        <v-list-item-avatar
                            size="80"
                            color="grey"
                        >
                            <img :src="row.users_avatar_url">
                        </v-list-item-avatar>
                    </v-list-item>
                </v-card-text>
            </v-card>
        </v-dialog>
        <v-dialog v-model="dialog.absence" max-width="490" persistent>
            <v-card>
                <v-card-title class="secondary headline white--text">{{dialog.title}} <v-spacer></v-spacer>
                    <v-btn color="white" outlined @click.stop="dialog.absence = false">TUTUP</v-btn></v-card-title>
                    <v-subheader class="secondary--text font-weight-bold"><v-spacer></v-spacer>{{ this.$functions.FormatDateIndoWithDayName(filter.sdate) }} <span v-if="filter.sdate !== filter.edate"> - {{ this.$functions.FormatDateIndoWithDayName(filter.edate) }}</span></v-subheader>
                <v-card-text class="card-text-scrollable">
                    <v-progress-linear
                    indeterminate
                    color="fourth"
                    rounded
                    class="mb-2"
                    v-if="loading.absence"
                    ></v-progress-linear>
                    <v-list-item three-line v-for="row in posts.absence" :key="`${row.absence_date}${row.absence_usersid}`">
                        <v-list-item-content v-if="dialog.title === 'CUTI ATAU SAKIT'" @click="OpenLeaveMenu(row.absence_leavecategory,row.absence_leaveid)">
                            <v-list-item-title>{{$functions.FormatDateIndoWithDayName(row.absence_date)}}</v-list-item-title>
                            <v-list-item-subtitle>{{row.absence_usersemployeeid}} - {{row.absence_usersname}}</v-list-item-subtitle>
                            <v-list-item-subtitle>{{row.absence_remarks}}</v-list-item-subtitle>
                        </v-list-item-content>
                        <v-list-item-content v-else @click="OpenAbsence(row.absence_date,row.absence_usersid)">
                            <v-list-item-title>{{$functions.FormatDateIndoWithDayName(row.absence_date)}}</v-list-item-title>
                            <v-list-item-subtitle>{{row.absence_usersemployeeid}} - {{row.absence_usersname}}</v-list-item-subtitle>
                            <v-list-item-subtitle>IN: {{row.absence_timein}} - OUT: {{row.absence_timeout}}</v-list-item-subtitle>
                            <v-list-item-subtitle>Notes IN: {{row.absence_ffotimeinstatusdesc}}</v-list-item-subtitle>
                            <v-list-item-subtitle>Notes OUT: {{row.absence_ffotimeoutstatusdesc}}</v-list-item-subtitle>
                            <v-list-item-subtitle>{{row.absence_remarks}}</v-list-item-subtitle>
                        </v-list-item-content>
            
                        <v-list-item-avatar
                            size="80"
                            color="grey"
                        >
                            <img :src="row.absence_usersavatarurl">
                        </v-list-item-avatar>
                    </v-list-item>
                </v-card-text>
            </v-card>
        </v-dialog>
        <v-dialog v-model="dialog.todo" max-width="490" persistent>
            <v-card>
                <v-card-title class="secondary headline white--text">{{dialog.title}} <v-spacer></v-spacer>
                    <v-btn color="white" outlined @click.stop="dialog.todo = false">TUTUP</v-btn></v-card-title>
                <v-card-text class="card-text-scrollable">
                    <v-progress-linear
                    indeterminate
                    color="fourth"
                    rounded
                    class="mb-2"
                    v-if="loading.todo"
                    ></v-progress-linear>
                    <v-list-item three-line v-for="row in posts.todo" :key="row.todo_id">
                        <v-list-item-content>
                            <v-list-item-title>{{$functions.FormatDateIndoWithDayName(row.todo_date)}}</v-list-item-title>
                            <v-list-item-subtitle>{{row.todo_users_employeeid}} - {{row.todo_users_name}}</v-list-item-subtitle>
                            <v-list-item-subtitle>{{row.todo_desc}}</v-list-item-subtitle>
                        </v-list-item-content>
            
                        <v-list-item-avatar
                            size="80"
                            color="grey"
                        >
                            <img :src="row.todo_users_avaurl">
                        </v-list-item-avatar>
                    </v-list-item>
                </v-card-text>
            </v-card>
        </v-dialog>
        <v-dialog v-model="dialog.detailabsence" max-width="490">
            <v-card>
                <v-card-title class="secondary headline white--text"><v-avatar class="mr-2"><v-img :src="form.absence_usersavatarurl"></v-img></v-avatar> {{form.absence_usersname}}</v-card-title>
                <v-progress-linear
                indeterminate
                color="fourth"
                rounded
                v-if="loading.detailabsence"
                ></v-progress-linear>
                <v-card-text>
                    <div class="text-center">
                        <div class="font-weight-bold green--text">IN: {{form.absence_timein}} <span v-if="form.absence_timelate !== '00:00'">&bull; TELAT: {{$functions.FormatTimeToWords(form.absence_timelate)}}</span></div>
                        <div><img :src="form.absence_timeinphoto" height="210px"></div>
                        <div><iframe :src="form.absence_timein_url" width="100%" height="175" frameborder="0"></iframe></div>
                    </div>
                    <br>
                    <v-divider></v-divider>
                    <br>
                    <div v-if="form.absence_timeout !== '00:00'" class="text-center">
                        <div class="font-weight-bold red--text">OUT: {{form.absence_timeout}} <span v-if="form.absence_timeearly !== '00:00'">&bull; LEBIH CEPAT: {{$functions.FormatTimeToWords(form.absence_timeearly)}}</span></div>
                        <div><img :src="form.absence_timeoutphoto" height="210px"></div>
                        <div><iframe :src="form.absence_timeout_url" width="100%" height="175" frameborder="0"></iframe></div>
                    </div>
                </v-card-text>
                <v-card-actions>
                    {{$functions.FormatDateIndoWithDayName(form.absence_date)}}
                    <v-spacer></v-spacer>
                    <v-btn color="secondary" outlined @click.stop="dialog.detailabsence = false">{{confirm.close}}</v-btn>
                </v-card-actions>
        </v-card>
        </v-dialog>
        <v-dialog v-model="dialog.balance" fullscreen persistent>
            <v-card>
                <v-card-title class="secondary headline white--text">{{form.balance_title}} <v-spacer></v-spacer>
                    <v-btn color="white" outlined @click.stop="dialog.balance = false">TUTUP</v-btn></v-card-title>
                    <v-subheader class="secondary--text font-weight-bold"><v-spacer></v-spacer></v-subheader>
                <v-card-text class="card-text-scrollable">
                    <v-progress-linear
                    indeterminate
                    color="fourth"
                    rounded
                    class="mb-2"
                    v-if="loading.balance"
                    ></v-progress-linear>
                    <v-row>
                        <v-col v-for="row in posts.balance" :key="`${row.usersbalance_year}${row.usersbalance_usersid}${row.usersbalance_modul}${row.usersbalance_type}`" cols="12" md="6" lg="4">
                          <v-card class="pa-4" outlined @click="GetBalance(row.usersbalance_modul,row.usersbalance_year,row.usersbalance_realyear,row.usersbalance_usersid,row.usersbalance_type,row.usersbalance_typedesc,row.usersbalance_used)">
                            <v-card-title class="text-h6 font-weight-bold">
                              {{ $functions.BalanceModul(row.usersbalance_modul) }}
                            </v-card-title>
                            <v-card-subtitle>
                              {{ row.usersbalance_typedesc }}
                            </v-card-subtitle>
                            <v-card-text>
                              <p class="mb-2">Saldo Awal: <strong>{{$functions.NewFormatNumber(row.usersbalance_balance,0) }}</strong></p>
                              <p class="mb-2">Saldo Terpakai: <strong>{{$functions.NewFormatNumber(row.usersbalance_used,0) }}</strong></p>
                              <p class="mb-2">Saldo Sisa: <strong>{{$functions.NewFormatNumber(row.usersbalance_remaining,0) }}</strong></p>
                            </v-card-text>
                          </v-card>
                        </v-col>
                      </v-row>
                </v-card-text>
            </v-card>
        </v-dialog>
        <v-dialog v-model="dialog.leave" fullscreen persistent>
            <v-card>
                <v-card-title class="secondary headline white--text">{{form.leave_title}} <v-spacer></v-spacer>
                    <!-- <app-download class="mx-2" outlined :download_year="form.leave_year" :download_usersid="form.leave_usersid" download_modul="leave" download_type="CT"></app-download> -->
                    <v-btn color="white" outlined @click.stop="dialog.leave = false">X</v-btn>
                </v-card-title>
                <v-card-text class="card-text-scrollable">
                    <v-progress-linear
                    indeterminate
                    color="fourth"
                    rounded
                    class="mb-2"
                    v-if="loading.leave"
                    ></v-progress-linear>
                    <v-card
                        class="mx-auto mb-2"
                        max-width="344"
                        outlined
                        v-for="row in posts.leave"
                        :key="row.leave_id"
                        @click="GoTo('leave',row.leave_id)"
                    >
                        <v-list-item three-line>
                        <v-list-item-content>
                            <div class="text-overline mb-4">
                            {{ $functions.FormatDateIndoWithDayName(row.leave_sdate) }} <span v-if="row.leave_sdate !== row.leave_edate">s/d {{ $functions.FormatDateIndoWithDayName(row.leave_edate) }}</span>
                            </div>
                            <v-list-item-subtitle class="title">{{row.leave_usersname}}</v-list-item-subtitle>
                            <v-list-item-subtitle>{{row.leave_remarks}}</v-list-item-subtitle>
                        </v-list-item-content>

                        <v-list-item-avatar
                            size="80"
                            color="grey"
                        >
                            <img :src="row.leave_usersavatarurl">
                        </v-list-item-avatar>
                        </v-list-item>

                        <v-card-actions>
                        <small class="ml-2"><v-icon>timer</v-icon> {{ row.leave_duration }} Hari</small><v-spacer></v-spacer><small><v-chip
                            class="ma-2"
                            color="primary"
                            label
                            text-color="white"
                        >
                            <v-icon left>
                            mdi-label
                            </v-icon>
                            {{ row.leave_statusdesc }}
                        </v-chip></small>
                        </v-card-actions>
                    </v-card>
                </v-card-text>
            </v-card>
        </v-dialog>
        <v-dialog v-model="dialog.medical" fullscreen persistent>
            <v-card>
                <v-card-title class="secondary headline white--text">
                {{ form.medical_title }}
                <v-spacer></v-spacer>
                <!-- <app-download
                    class="mx-2"
                    outlined
                    :download_year="form.medical_year"
                    :download_usersid="form.medical_usersid"
                    download_modul="medical"
                    :download_type="form.medical_type"
                ></app-download> -->
                <v-btn color="white" outlined @click.stop="dialog.medical = false">X</v-btn>
                </v-card-title>

                <v-card-text class="card-text-scrollable">
                <v-progress-linear
                    indeterminate
                    color="fourth"
                    rounded
                    class="mb-2"
                    v-if="loading.medical"
                ></v-progress-linear>

                <v-card
                    class="mx-auto mb-2"
                    max-width="344"
                    outlined
                    v-for="row in posts.medical"
                    :key="row.medical_id"
                    @click="GoTo('medical',row.medical_id)"
                >
                    <v-list-item three-line>
                    <v-list-item-content>
                        <div class="text-overline mb-4">
                        {{ $functions.FormatDateIndoWithDayName(row.medical_date) }}
                        <span v-if="row.medical_date !== row.medical_edate">
                            s/d {{ $functions.FormatDateIndoWithDayName(row.medical_edate) }}
                        </span> - <span class="primary--text">{{ row.medical_statusdesc }}</span>
                        </div>
                        <v-list-item-subtitle class="title">{{ row.medical_usersname }}</v-list-item-subtitle>
                        <v-list-item-subtitle>{{ row.medical_remarks }}</v-list-item-subtitle>
                    </v-list-item-content>

                    <v-list-item-avatar size="80" color="grey">
                        <img :src="row.medical_usersavatarurl" />
                    </v-list-item-avatar>
                    </v-list-item>

                    <v-card-actions class="flex-wrap">
                    <small class="ml-2">
                        <v-icon small class="mr-1">mdi-timer</v-icon> {{ row.medical_duration }} Hari
                    </small>

                    <v-spacer></v-spacer>

                    <div class="ml-2">
                        <v-icon small class="mr-1">mdi-currency-idr</v-icon>
                        Rp. {{ $functions.NewFormatNumber(row.medical_total, 0) }}
                    </div>

                    <v-spacer></v-spacer>

                    <!-- Tombol Attachment -->
                    <v-btn
                        v-if="row.medical_attachmentpath"
                        small
                        color="secondary"
                        text
                        :href="row.medical_attachmentpathurl"
                        target="_blank"
                        class="ma-1"
                        @click.stop
                    >
                        <v-icon left small>mdi-paperclip</v-icon>
                        Lampiran
                    </v-btn>
                    </v-card-actions>
                </v-card>
                </v-card-text>
            </v-card>
        </v-dialog>
        
        <v-dialog v-model="dialog.entertainment" fullscreen persistent>
            <v-card>
                <v-card-title class="secondary headline white--text">{{form.entertainment_title}} <v-spacer></v-spacer>
                    <!-- <app-download class="mx-2" outlined :download_year="form.entertainment_year" :download_usersid="form.entertainment_usersid" download_modul="entertainment" :download_type="form.entertainment_type"></app-download> -->
                    <v-btn color="white" outlined @click.stop="dialog.entertainment = false">X</v-btn>
                </v-card-title>
                <v-card-text class="card-text-scrollable">
                    <v-progress-linear
                    indeterminate
                    color="fourth"
                    rounded
                    class="mb-2"
                    v-if="loading.entertainment"
                    ></v-progress-linear>
                    <v-card
                        class="mx-auto mb-2"
                        max-width="344"
                        outlined
                        v-for="row in posts.entertainment"
                        :key="row.entertainment_id"
                        @click="GoTo('entertainment',row.entertainment_id)"
                    >
                        <v-list-item three-line>
                        <v-list-item-content>
                            <div class="text-overline mb-4">
                            {{ $functions.FormatDateIndoWithDayName(row.entertainment_sdate) }} <span v-if="row.entertainment_sdate !== row.entertainment_edate">s/d {{ $functions.FormatDateIndoWithDayName(row.entertainment_edate) }}</span>
                             - <span class="primary--text">{{ row.entertainment_statusdesc }}</span>
                            </div>
                            <v-list-item-subtitle class="title">{{row.entertainment_usersname}}</v-list-item-subtitle>
                            <v-list-item-subtitle>{{row.entertainment_remarks}}</v-list-item-subtitle>
                        </v-list-item-content>

                        <v-list-item-avatar
                            size="80"
                            color="grey"
                        >
                            <img :src="row.entertainment_usersavatarurl">
                        </v-list-item-avatar>
                        </v-list-item>

                        <v-card-actions class="flex-wrap">
                        <small class="ml-2">
                            <v-icon small class="mr-1">mdi-map-marker</v-icon> {{ row.entertainment_place }}
                        </small>

                        <v-spacer></v-spacer>

                        <div class="ml-2">
                            <v-icon small class="mr-1">mdi-currency-idr</v-icon>
                            Rp. {{ $functions.NewFormatNumber(row.entertainment_total, 0) }}
                        </div>

                        <v-spacer></v-spacer>

                        <!-- Tombol Attachment -->
                        <v-btn
                            v-if="row.entertainment_attachmentpath"
                            small
                            color="secondary"
                            text
                            :href="row.entertainment_attachmentpathurl"
                            target="_blank"
                            class="ma-1"
                            @click.stop
                        >
                            <v-icon left small>mdi-paperclip</v-icon>
                            Lampiran
                        </v-btn>
                        </v-card-actions>
                    </v-card>
                </v-card-text>
            </v-card>
        </v-dialog>
        <v-dialog v-model="dialog.transportation" fullscreen persistent>
            <v-card>
                <v-card-title class="secondary headline white--text">{{form.transportation_title}} <v-spacer></v-spacer>
                    <!-- <app-download class="mx-2" outlined :download_year="form.transportation_year" :download_usersid="form.transportation_usersid" download_modul="transportation" :download_type="form.transportation_type"></app-download> -->
                    <v-btn color="white" outlined @click.stop="dialog.transportation = false">X</v-btn>
                </v-card-title>
                <v-card-text class="card-text-scrollable">
                    <v-progress-linear
                    indeterminate
                    color="fourth"
                    rounded
                    class="mb-2"
                    v-if="loading.transportation"
                    ></v-progress-linear>
                    <v-card
                        class="mx-auto mb-2"
                        max-width="344"
                        outlined
                        v-for="row in posts.transportation"
                        :key="row.transportation_id"
                        @click="GoTo('transportation',row.transportation_id)"
                    >
                        <v-list-item three-line>
                        <v-list-item-content>
                            <div class="text-overline mb-4">
                            {{ $functions.FormatDateIndoWithDayName(row.transportation_sdate) }} <span v-if="row.transportation_sdate !== row.transportation_edate">s/d {{ $functions.FormatDateIndoWithDayName(row.transportation_edate) }}</span>
                            - <span class="primary--text">{{ row.transportation_statusdesc }}</span>
                            </div>
                            <v-list-item-subtitle class="title">{{row.transportation_usersname}}</v-list-item-subtitle>
                            <v-list-item-subtitle>{{row.transportation_remarks}}</v-list-item-subtitle>
                        </v-list-item-content>

                        <v-list-item-avatar
                            size="80"
                            color="grey"
                        >
                            <img :src="row.transportation_usersavatarurl">
                        </v-list-item-avatar>
                        </v-list-item>

                        <v-card-actions class="flex-wrap">
                        <small class="ml-2">
                            <v-icon small class="mr-1">mdi-map-marker</v-icon> {{ row.transportation_arrive }}
                        </small>

                        <v-spacer></v-spacer>

                        <div class="ml-2">
                            <v-icon small class="mr-1">mdi-currency-idr</v-icon>
                            Rp. {{ $functions.NewFormatNumber(row.transportation_total, 0) }}
                        </div>

                        <v-spacer></v-spacer>

                        <!-- Tombol Attachment -->
                        <v-btn
                            v-if="row.transportation_attachmentpath"
                            small
                            color="secondary"
                            text
                            :href="row.transportation_attachmentpathurl"
                            target="_blank"
                            class="ma-1"
                            @click.stop
                        >
                            <v-icon left small>mdi-paperclip</v-icon>
                            Lampiran
                        </v-btn>
                        </v-card-actions>
                    </v-card>
                </v-card-text>
            </v-card>
        </v-dialog>
        <v-dialog v-model="dialog.report" fullscreen persistent>
        <v-card>
            <v-card-title class="secondary headline white--text">
            Laporan 
            <v-spacer></v-spacer>
            <v-btn color="white" outlined @click.stop="dialog.report = false">X</v-btn>
            </v-card-title>

            <v-card-text class="card-text-scrollable">
            <v-subheader class="secondary--text font-weight-bold" @click="filter.dialog = true"><v-spacer></v-spacer>Periode: {{ filter.sdate }} <span v-if="filter.sdate !== filter.edate">&nbsp;s/d {{ filter.edate }}</span></v-subheader>
            <v-progress-linear
                indeterminate
                color="fourth"
                rounded
                class="mb-2"
                v-if="loading.report"
            ></v-progress-linear>

            <v-list two-line>
                <v-list-item
                v-for="item in report"
                :key="item.id"
                link
                @click="Download(item)"
                >
                <v-list-item-avatar color="primary" size="48">
                    <v-icon dark>
                    {{ item.icon }}
                    </v-icon>
                </v-list-item-avatar>

                <v-list-item-content>
                    <v-list-item-title class="font-weight-medium">
                    {{ item.desc }}
                    </v-list-item-title>
                    <v-list-item-subtitle>
                    Klik untuk download
                    </v-list-item-subtitle>
                </v-list-item-content>

                <v-list-item-action>
                    <v-progress-circular
                        v-if="item.loading"
                        indeterminate
                        size="20"
                        width="2"
                        color="primary"
                    />
                    <v-icon v-else>mdi-download</v-icon>
                    </v-list-item-action>
                </v-list-item>
            </v-list>
            </v-card-text>
        </v-card>
        </v-dialog>

        <app-snackbar 
        :dialog="snackbar.dialog"
        :color="snackbar.color"
        :text="snackbar.text"
        :timeout="snackbar.timeout"
        @close="snackbar.dialog = false"
      ></app-snackbar>
    </div>
</template>
<script>
    export default {
        data: () => ({
            posts:{
                employees: [],
                joinresign: [],
                absencetodo: [],
                users: [],
                todo: [],
                leave: [],
                medical: [],
                entertainment: [],
                transportation: [],
            },
            access: {
                read: 0
            },
            loading: {
                page: false,
                absence: false,
                employee: false,
                todo: false,
                balance: false,
                leave: false,
                medical: false,
                entertainment: false,
                transportation: false,
            },
            pages: {
                limit:10,
                offset:10,
                fetch:10,
            },
            current_date: '',
            form: {
                sdate: new Date().toISOString().substr(0, 10),
                edate: new Date().toISOString().substr(0, 10),
                absence_usersname: '',
                absence_usersavatarurl: '',
                absence_date: '',
                absence_timein: '',
                absence_timeout: '',
                absence_latitude_in: '',
                absence_longitude_in: '',
                absence_geolocation_in: '',
                absence_latitude_out: '',
                absence_longitude_out: '',
                absence_geolocation_out: '',
                absence_timein_url: '',
                absence_timeout_url: '',
                absence_timeinphoto: '',
                absence_timeoutphoto: '',
                absence_timelate: '',
                absence_timeearly: '',
                balance_title: '',
                leave_title: '',
                leave_year: '',
                leave_usersid: '',
                leave_type: '',
                medical_title: '',
                medical_year: '',
                medical_usersid: '',
                medical_type: '',
                entertainment_title: '',
                entertainment_year: '',
                entertainment_usersid: '',
                entertainment_type: '',
                transportation_title: '',
                transportation_year: '',
                transportation_usersid: '',
                transportation_type: '',
            },
            dialog: {
                employee: false,
                absence: false,
                todo: false,
                detailabsence: false,
                balance: false,
                leave: false,
                medical: false,
                entertainment: false,
                transportation: false,
                report: false,
            },
            modal: {
                sdate: false,
                edate: false,
            },
            filter: {
                dialog: false,
                title: 'Filter Periode',
                close: 'Tutup',
                company: '',
                sdate: new Date().toISOString().substr(0, 10),
                edate: new Date().toISOString().substr(0, 10),
            },
            report: [
                {"icon":"healing","id":"report_medical","desc":"Laporan Kesehatan", loading: false },
                {"icon":"redeem","id":"report_entertainment","desc":"Laporan Bina Relasi", loading: false },
                {"icon":"commute","id":"report_transport","desc":"Laporan Transportasi", loading: false },
                {"icon":"today","id":"report_absence","desc":"Laporan Absensi", loading: false },
            ],
            confirm: {
                dialog: false,
                title: '',
                text: '',
                ok: 'OK',
                close: 'Tutup',
            },
            snackbar: {
                dialog: false,
                timeout: 3000,
                text: '',
                color: 'error'
            }
        }),
        created() {
            if (this.$functions.UsersCompany() !== '') {
                this.filter.company = this.$functions.UsersCompany()
            }
            this.Access()
            this.Employee()
            this.AbsenceTodo()
        },
        // Check If Back Button Press, Modal Close
       beforeRouteLeave(to, from, next) {
        if (
            this.modal.sdate || this.modal.edate ||
            this.dialog.absence || this.dialog.detailabsence || this.dialog.employee ||
            this.dialog.todo || this.dialog.balance || this.dialog.leave || this.dialog.medical ||
            this.dialog.entertainment || this.dialog.transportation
        ) {
            // Tutup semua dialog/modal
            this.modal.sdate = false
            this.modal.edate = false
            this.dialog.absence = false
            this.dialog.detailabsence = false
            this.dialog.employee = false
            this.dialog.todo = false
            this.dialog.balance = false
            this.dialog.leave = false
            this.dialog.medical = false
            this.dialog.entertainment = false
            this.dialog.transportation = false

            // Tunggu sejenak agar animasi penutupan selesai
            setTimeout(() => {
            // lanjut navigasi secara manual
            this.$router.push(to.fullPath)
            }, 300) // sesuaikan dengan durasi transisi Vuetify
            next(false); // hentikan navigasi bawaan
        } else {
            next();
        }
        },
        computed: {
            sdate_value () {
                return this.form.sdate ? this.$moment(this.form.sdate).format('LL') : ''
            },
            edate_value () {
                return this.form.edate ? this.$moment(this.form.edate).format('LL') : ''
            }
        },
        methods:{
            Access () {
                let modul = 'myreport'
                let formdata = {
                    menu_id: modul,
                    users_id: this.$functions.UsersID(),
                    order_by: 'menu_id',
                    order_type: 'ASC',
                    flag: 'mobileapp',
                    limit: this.limit,
                }
                let param 	   = this.$functions.ParamPOST(formdata)
                this.$axios.post(this.$functions.UrlPOST('apiListMenuUser'),param,{
                    headers: {
                        'Content-Type': 'text/plain; charset=ISO-8859-1'
                    }
                })
                .then(response => {
                    let priv = response.data
                    if (priv.length > 0) {
                        if (priv[0].feedback !== 'Y') {
                            this.SnackBar(true, 'error', this.$functions.ErrorCode(), 0)
                        } else {
                        	if (priv[0].usersmenu_read === 0) {
                                let url = 'account'
                                this.$router.push({name: url})
                            } else {
                                this.access.read  	= priv[0].usersmenu_read
                            }
                        }
                    } else {
                        this.SnackBar(true, "error", this.$functions.NoPriviledge(modul), 0)
                    }
                })
                .catch(e => {
                    this.SnackBar(true, 'error', e, 0)
                })
            },
            FilterDate () {
                this.filter.dialog = false
                this.AbsenceTodo()
            },
            List (flag) {
                this.filter.company = flag
                this.Employee()
                this.AbsenceTodo()
            },
            Employee () {
                this.loading.page = true
                let formdata = {
                  users_company: this.filter.company,
                  flag: 'mobileapp',
                }
                let param 	   = this.$functions.ParamPOST(formdata)
                this.$axios.post(this.$functions.UrlPOST('apiListUsersReportEmployee'),param,{
                    headers: {
                        'Content-Type': 'text/plain; charset=ISO-8859-1'
                    }
                })
                .then(response => {
                    let feedback = response.data
                    if (feedback.length > 0) {
                        this.posts.employees = [
                            {employee_flag: 'CABANG',employee_icon: 'apartment',employee_flag_count: feedback[0].report_branch_count},
                            {employee_flag: 'KARYAWAN',employee_icon: 'badge',employee_flag_count: feedback[0].report_gender_female + feedback[0].report_gender_male},
                            {employee_flag: 'MANAGEMEN',employee_icon: 'supervisor_account',employee_flag_count: feedback[0].report_flag_management},
                            {employee_flag: 'PERMANENT',employee_icon: '',employee_flag_count: feedback[0].report_status_permanent},
                            {employee_flag: 'PKWT',employee_icon: '',employee_flag_count: feedback[0].report_status_pkwt},
                            {employee_flag: 'PROBATION',employee_icon: '',employee_flag_count: feedback[0].report_status_probation},
                            {employee_flag: 'OUTSOURCE',employee_icon: '',employee_flag_count: feedback[0].report_status_outsource},
                            {employee_flag: 'APPRENT',employee_icon: '',employee_flag_count: feedback[0].report_status_apprent},
                            {employee_flag: 'WANITA',employee_icon: 'woman',employee_flag_count: feedback[0].report_gender_female},
                            {employee_flag: 'PRIA',employee_icon: 'man',employee_flag_count: feedback[0].report_gender_male},
                        ]
                        this.posts.joinresign = [
                            {employee_flag: 'JOIN BULAN INI',employee_icon: 'calendar_month',employee_flag_count: feedback[0].report_join_month},
                            {employee_flag: 'JOIN TAHUN INI',employee_icon: 'calendar_today',employee_flag_count: feedback[0].report_join_year},
                            {employee_flag: 'RESIGN BULAN INI',employee_icon: 'calendar_month',employee_flag_count: feedback[0].report_resign_month},
                        ]
                    } else {
                        this.SnackBar(true, 'error', this.$functions.ErrorCode(), 0)
                    }
                    this.loading.page = false
                })
                .catch(e => {
                    this.SnackBar(true, 'error', e, 3000)
                    this.loading.page = false
                })
            },
            AbsenceTodo () {
                this.loading.page = true
                let formdata = {
                  users_company: this.filter.company,
                  users_sdate: this.filter.sdate,
                  users_edate: this.filter.edate,
                  flag: 'mobileapp',
                }
                let param 	   = this.$functions.ParamPOST(formdata)
                this.$axios.post(this.$functions.UrlPOST('apiListUsersReportAbsenceTodo'),param,{
                    headers: {
                        'Content-Type': 'text/plain; charset=ISO-8859-1'
                    }
                })
                .then(response => {
                    let feedback = response.data
                    if (feedback.length > 0) {
                        this.posts.absencetodo = [
                            {employee_flag: 'LAPORAN',employee_icon: 'dashboard',employee_flag_count: 0},
                            {employee_flag: 'KESEHATAN',employee_icon: 'healing',employee_flag_count: feedback[0].report_absence_medical},
                            {employee_flag: 'TRANSPORTASI',employee_icon: 'commute',employee_flag_count: feedback[0].report_absence_transportation},
                            {employee_flag: 'BINA RELASI',employee_icon: 'redeem',employee_flag_count: feedback[0].report_absence_entertainment},
                            {employee_flag: 'ABSEN',employee_icon: 'today',employee_flag_count: feedback[0].report_absence_presence},
                            {employee_flag: 'TIDAK ABSEN',employee_icon: 'logout',employee_flag_count: feedback[0].report_absence_absence},
                            {employee_flag: 'CUTI ATAU SAKIT',employee_icon: 'event_busy',employee_flag_count: feedback[0].report_absence_leave},
                            {employee_flag: 'SUDAH TODO',employee_icon: 'task_alt',employee_flag_count: feedback[0].report_todo_yes},
                            {employee_flag: 'BELUM TODO',employee_icon: 'do_not_disturb_on',employee_flag_count: feedback[0].report_todo_no},
                        ]
                    } else {
                        this.SnackBar(true, 'error', this.$functions.ErrorCode(), 0)
                    }
                    this.loading.page = false
                })
                .catch(e => {
                    this.SnackBar(true, 'error', e, 3000)
                    this.loading.page = false
                })
            },
            GetEmployee (filter) {
                this.dialog.employee = true
                this.dialog.title = filter
                this.loading.employee = true
                let formdata = {
                  users_company: this.filter.company,
                  users_sdate: this.filter.sdate,
                  users_edate: this.filter.edate,
                  users_filter: filter,
                  flag: 'mobileapp',
                  order_by: 'users_id',
                  order_type: 'ASC',
                }
                let param 	   = this.$functions.ParamPOST(formdata)
                this.$axios.post(this.$functions.UrlPOST('apiListUsersShort'),param,{
                    headers: {
                        'Content-Type': 'text/plain; charset=ISO-8859-1'
                    }
                })
                .then(response => {
                    let feedback = response.data
                    if (feedback.length > 0) {
                        this.posts.users = feedback
                    } else {
                        this.posts.users = feedback
                        this.SnackBar(true, 'error', this.$functions.ErrorCode(), 0)
                    }
                    this.loading.employee = false
                })
                .catch(e => {
                    this.SnackBar(true, 'error', e, 3000)
                    this.loading.employee = false
                })
            },
            GetAbsenceTodo (filter) {
                if (filter === 'ABSEN' || filter === 'TIDAK ABSEN'|| filter === 'CUTI ATAU SAKIT') {
                    this.GetAbsence(filter)
                } else if (filter === 'BELUM TODO') {
                    this.GetEmployee(filter)
                } else if (filter === 'SUDAH TODO') {
                    this.GetTodo(filter)
                } else if (filter === 'KESEHATAN') {
                    this.GetMedical(filter)
                } else if (filter === 'BINA RELASI') {
                    this.GetEntertainment(filter)
                } else if (filter === 'TRANSPORTASI') {
                    this.GetTransportation(filter)
                } else if (filter === 'LAPORAN') {
                    this.GetReport()
                }
            },
            GetReport() {
                this.dialog.report = true
            },
            GetMedical (filter) {
                this.dialog.medical = true
                this.form.medical_title = filter
                this.loading.medical = true
                let formdata = {
                  medical_company: this.filter.company,
                  medical_date: this.filter.sdate,
                  medical_edate: this.filter.edate,
                  medical_filter: filter,
                  flag: 'mobileapp',
                  order_by: 'medical_date',
                  order_type: 'DESC',
                }
                let param 	   = this.$functions.ParamPOST(formdata)
                this.$axios.post(this.$functions.UrlPOST('apiListMedical'),param,{
                    headers: {
                        'Content-Type': 'text/plain; charset=ISO-8859-1'
                    }
                })
                .then(response => {
                    let feedback = response.data
                    if (feedback.length > 0) {
                        this.posts.medical = feedback
                    } else {
                        this.posts.medical = feedback
                        this.SnackBar(true, 'error', this.$functions.ErrorCode(), 0)
                    }
                    this.loading.medical = false
                })
                .catch(e => {
                    this.SnackBar(true, 'error', e, 3000)
                    this.loading.medical = false
                })
            },
            GetEntertainment (filter) {
                this.dialog.entertainment = true
                this.form.entertainment_title = filter
                this.loading.entertainment = true
                let formdata = {
                  entertainment_company: this.filter.company,
                  entertainment_sdate: this.filter.sdate,
                  entertainment_edate: this.filter.edate,
                  entertainment_filter: filter,
                  flag: 'mobileapp',
                  order_by: 'entertainment_sdate',
                  order_type: 'DESC',
                }
                let param 	   = this.$functions.ParamPOST(formdata)
                this.$axios.post(this.$functions.UrlPOST('apiListEntertainment'),param,{
                    headers: {
                        'Content-Type': 'text/plain; charset=ISO-8859-1'
                    }
                })
                .then(response => {
                    let feedback = response.data
                    if (feedback.length > 0) {
                        this.posts.entertainment = feedback
                    } else {
                        this.posts.entertainment = feedback
                        this.SnackBar(true, 'error', this.$functions.ErrorCode(), 0)
                    }
                    this.loading.entertainment = false
                })
                .catch(e => {
                    this.SnackBar(true, 'error', e, 3000)
                    this.loading.entertainment = false
                })
            },
            GetTransportation (filter) {
                this.dialog.transportation = true
                this.form.transportation_title = filter
                this.loading.transportation = true
                let formdata = {
                  transportation_company: this.filter.company,
                  transportation_sdate: this.filter.sdate,
                  transportation_edate: this.filter.edate,
                  transportation_filter: filter,
                  flag: 'mobileapp',
                  order_by: 'transportation_sdate',
                  order_type: 'DESC',
                }
                let param 	   = this.$functions.ParamPOST(formdata)
                this.$axios.post(this.$functions.UrlPOST('apiListTransportation'),param,{
                    headers: {
                        'Content-Type': 'text/plain; charset=ISO-8859-1'
                    }
                })
                .then(response => {
                    let feedback = response.data
                    if (feedback.length > 0) {
                        this.posts.transportation = feedback
                    } else {
                        this.posts.transportation = feedback
                        this.SnackBar(true, 'error', this.$functions.ErrorCode(), 0)
                    }
                    this.loading.transportation = false
                })
                .catch(e => {
                    this.SnackBar(true, 'error', e, 3000)
                    this.loading.transportation = false
                })
            },
            GetAbsence (filter) {
                this.dialog.absence = true
                this.dialog.title = filter
                this.loading.absence = true
                let formdata = {
                  absence_company: this.filter.company,
                  absence_sdate: this.filter.sdate,
                  absence_edate: this.filter.edate,
                  absence_filter: filter,
                  flag: 'mobileapp',
                  order_by: 'absence_date',
                  order_type: 'ASC',
                }
                let param 	   = this.$functions.ParamPOST(formdata)
                this.$axios.post(this.$functions.UrlPOST('apiListAbsence'),param,{
                    headers: {
                        'Content-Type': 'text/plain; charset=ISO-8859-1'
                    }
                })
                .then(response => {
                    let feedback = response.data
                    if (feedback.length > 0) {
                        this.posts.absence = feedback
                    } else {
                        this.posts.absence = feedback
                        this.SnackBar(true, 'error', this.$functions.ErrorCode(), 0)
                    }
                    this.loading.absence = false
                })
                .catch(e => {
                    this.SnackBar(true, 'error', e, 3000)
                    this.loading.absence = false
                })
            },
            GetTodo (filter) {
                this.dialog.todo = true
                this.dialog.title = filter
                this.loading.todo = true
                let formdata = {
                  todo_company: this.filter.company,
                  todo_sdate: this.filter.sdate,
                  todo_edate: this.filter.edate,
                  todo_filter: filter,
                  flag: 'mobileapp',
                  order_by: 'todo_date,todo_cuser',
                  order_type: 'ASC',
                }
                let param 	   = this.$functions.ParamPOST(formdata)
                this.$axios.post(this.$functions.UrlPOST('apiListTodo'),param,{
                    headers: {
                        'Content-Type': 'text/plain; charset=ISO-8859-1'
                    }
                })
                .then(response => {
                    let feedback = response.data
                    if (feedback.length > 0) {
                        this.posts.todo = feedback
                    } else {
                        this.posts.todo = feedback
                        this.SnackBar(true, 'error', this.$functions.ErrorCode(), 0)
                    }
                    this.loading.todo = false
                })
                .catch(e => {
                    this.SnackBar(true, 'error', e, 3000)
                    this.loading.todo = false
                })
            },
            GetData (flag, value) {
                switch (flag) {
                	case 'sdate':
                		this.$refs.dialog_sdate.save(value)
                        this.form.sdate = this.$moment(value).format('YYYY-MM-DD')
                        this.filter.sdate = this.$moment(value).format('YYYY-MM-DD')
                    break
                    case 'edate':
                		this.$refs.dialog_edate.save(value)
                        this.form.edate = this.$moment(value).format('YYYY-MM-DD')
                        this.filter.edate = this.$moment(value).format('YYYY-MM-DD')
                    break
                }
            },
            OpenAbsence(date,id) {
                this.dialog.detailabsence = true
                this.loading.detailabsence = true
                let formdata = {
                    absence_date: date,
                    absence_usersid: id,
                }
                let param 	   = this.$functions.ParamPOST(formdata)
                this.$axios.post(this.$functions.UrlPOST('apiListAbsence'),param,{
                headers: {
                    'Content-Type': 'text/plain; charset=ISO-8859-1'
                }
                })
                .then(response => {
                    let feedback = response.data
                    if (feedback.length > 0) {
                        if (feedback[0].feedback === 'Y') {
                        this.form.absence_usersname = feedback[0].absence_usersname
                        this.form.absence_usersavatarurl = feedback[0].absence_usersavatarurl
                        this.form.absence_date = feedback[0].absence_date
                        this.form.absence_timein = feedback[0].absence_timein
                        this.form.absence_timeout = feedback[0].absence_timeout
                        this.form.absence_latitude_in = feedback[0].absence_latitude_in
                        this.form.absence_longitude_in = feedback[0].absence_longitude_in
                        this.form.absence_geolocation_in = feedback[0].absence_geolocation_in
                        this.form.absence_latitude_out = feedback[0].absence_latitude_out
                        this.form.absence_longitude_out = feedback[0].absence_longitude_out
                        this.form.absence_geolocation_out = feedback[0].absence_geolocation_out
                        this.form.absence_timeinphoto = feedback[0].absence_timeinphoto
                        this.form.absence_timeoutphoto = feedback[0].absence_timeoutphoto
                        this.form.absence_timelate = feedback[0].absence_timelate
                        this.form.absence_timeearly = feedback[0].absence_timeearly
                        this.form.absence_timein_url = 'https://maps.google.com/maps?q='+feedback[0].absence_latitude_in+','+feedback[0].absence_longitude_in+'&t=&z=19&ie=UTF8&iwloc=&output=embed'
                        this.form.absence_timeout_url = 'https://maps.google.com/maps?q='+feedback[0].absence_latitude_out+','+feedback[0].absence_longitude_out+'&t=&z=19&ie=UTF8&iwloc=&output=embed'
                        } else {
                            this.SnackBar(true,'error',feedback[0].feedback,3000)
                        }
                    }
                    this.loading.detailabsence = false
                })
                .catch(e => {
                    this.SnackBar(true,'error',e,3000)
                    this.loading.detailabsence = false
                })
            },
            OpenLeaveMenu(category,id) {
                if (category === 'MK' || category === 'DN') {
                    this.$router.push({name: 'employeeleavemeetingdetail',params:{id:this.$functions.EncodeUrl(id)}})
                } else {
                    this.$router.push({name: 'employeeleavedetail',params:{id:this.$functions.EncodeUrl(id)}})
                }
            },
            Balance (id) {
                this.form.balance_title = id
                this.dialog.balance = true
                this.loading.balance = true
                let formdata = {
                  usersbalance_usersid: id,
                  usersbalance_year: String(this.$functions.Year()),
                  flag: 'mobileapp',
                  order_by: 'usersbalance_modul',
                  order_type: 'ASC',
                }
                let param 	   = this.$functions.ParamPOST(formdata)
                this.$axios.post(this.$functions.UrlPOST('apiListUsersBalance'),param,{
                    headers: {
                        'Content-Type': 'text/plain; charset=ISO-8859-1'
                    }
                })
                .then(response => {
                    let feedback = response.data
                    if (feedback.length > 0) {
                        this.posts.balance = feedback
                    } else {
                        this.posts.balance = feedback
                        this.SnackBar(true, 'error', this.$functions.ErrorCode(), 3000)
                    }
                    this.loading.balance = false
                })
                .catch(e => {
                    this.SnackBar(true, 'error', e, 3000)
                    this.loading.balance = false
                })
            },
            GetBalance(modul, year, realyear, usersid, type, typedesc, used) {
                if (used > 0) {
                    if (modul === 'leave') {
                        this.OpenLeave(realyear,usersid,type,typedesc)
                    } else if (modul === 'medical') {
                        this.OpenMedical(realyear,usersid,type,typedesc)
                    } else if (modul === 'entertainment') {
                        this.OpenEntertainment(realyear,usersid,type,typedesc)
                    } else if (modul === 'transportation') {
                        this.OpenTransportation(realyear,usersid,type,typedesc)
                    }
                } else {
                    this.SnackBar(true, 'error', 'Tidak ada data', 3000)
                }
            },
            OpenLeave (year, usersid, type,typedesc) {
                this.dialog.leave = true
                this.loading.leave = true
                this.form.leave_title = typedesc
                this.form.leave_year = year
                this.form.leave_usersid = usersid
                this.form.leave_type = type
                let formdata = {
                  leave_usersid: usersid,
                  leave_year: String(year),
                  flag: 'mobileapp',
                  order_by: 'leave_sdate',
                  order_type: 'DESC',
                }
                let param 	   = this.$functions.ParamPOST(formdata)
                this.$axios.post(this.$functions.UrlPOST('apiListLeave'),param,{
                    headers: {
                        'Content-Type': 'text/plain; charset=ISO-8859-1'
                    }
                })
                .then(response => {
                    let feedback = response.data
                    if (feedback.length > 0) {
                        this.posts.leave = feedback
                    } else {
                        this.posts.leave = feedback
                        this.SnackBar(true, 'error', this.$functions.ErrorCode(), 3000)
                    }
                    this.loading.leave = false
                })
                .catch(e => {
                    this.SnackBar(true, 'error', e, 3000)
                    this.loading.leave = false
                })
            },
            OpenMedical (year, usersid, type, typedesc) {
                this.dialog.medical = true
                this.loading.medical = true
                this.form.medical_title = typedesc
                this.form.medical_year = year
                this.form.medical_usersid = usersid
                this.form.medical_type = type
                let formdata = {
                  medical_usersid: usersid,
                  medical_year: String(year),
                  medical_type: type,
                  flag: 'mobileapp',
                  order_by: 'medical_date',
                  order_type: 'DESC',
                }
                let param 	   = this.$functions.ParamPOST(formdata)
                this.$axios.post(this.$functions.UrlPOST('apiListMedical'),param,{
                    headers: {
                        'Content-Type': 'text/plain; charset=ISO-8859-1'
                    }
                })
                .then(response => {
                    let feedback = response.data
                    if (feedback.length > 0) {
                        this.posts.medical = feedback
                    } else {
                        this.posts.medical = feedback
                        this.SnackBar(true, 'error', this.$functions.ErrorCode(), 3000)
                    }
                    this.loading.medical = false
                })
                .catch(e => {
                    this.SnackBar(true, 'error', e, 3000)
                    this.loading.medical = false
                })
            },
            OpenEntertainment (year, usersid, type, typedesc) {
                this.dialog.entertainment = true
                this.loading.entertainment = true
                this.form.entertainment_title = typedesc
                this.form.entertainment_year = year
                this.form.entertainment_usersid = usersid
                this.form.entertainment_type = type
                let formdata = {
                entertainment_usersid: usersid,
                entertainment_year: String(year),
                entertainment_type: type,
                flag: 'mobileapp',
                order_by: 'entertainment_sdate',
                order_type: 'DESC',
                }
                let param 	   = this.$functions.ParamPOST(formdata)
                this.$axios.post(this.$functions.UrlPOST('apiListEntertainment'),param,{
                    headers: {
                        'Content-Type': 'text/plain; charset=ISO-8859-1'
                    }
                })
                .then(response => {
                    let feedback = response.data
                    if (feedback.length > 0) {
                        this.posts.entertainment = feedback
                    } else {
                        this.posts.entertainment = feedback
                        this.SnackBar(true, 'error', this.$functions.ErrorCode(), 3000)
                    }
                    this.loading.entertainment = false
                })
                .catch(e => {
                    this.SnackBar(true, 'error', e, 3000)
                    this.loading.entertainment = false
                })
            },
            OpenTransportation (year, usersid, type, typedesc) {
                this.dialog.transportation = true
                this.loading.transportation = true
                this.form.transportation_title = typedesc
                this.form.transportation_year = year
                this.form.transportation_usersid = usersid
                this.form.transportation_type = type
                let formdata = {
                transportation_usersid: usersid,
                transportation_year: String(year),
                transportation_type: type,
                flag: 'mobileapp',
                order_by: 'transportation_sdate',
                order_type: 'DESC',
                }
                let param 	   = this.$functions.ParamPOST(formdata)
                this.$axios.post(this.$functions.UrlPOST('apiListTransportation'),param,{
                    headers: {
                        'Content-Type': 'text/plain; charset=ISO-8859-1'
                    }
                })
                .then(response => {
                    let feedback = response.data
                    if (feedback.length > 0) {
                        this.posts.transportation = feedback
                    } else {
                        this.posts.transportation = feedback
                        this.SnackBar(true, 'error', this.$functions.ErrorCode(), 3000)
                    }
                    this.loading.transportation = false
                })
                .catch(e => {
                    this.SnackBar(true, 'error', e, 3000)
                    this.loading.transportation = false
                })
            },
            GoTo (modul,id) {
                this.$router.push({name: 'employee'+modul+'detail',params:{id:this.$functions.EncodeUrl(id)}})
            },
            Download (item) {
                item.loading = true
                let formdata = {
                  url_type: 'report',
                  letter_reportcategory: item.id,
                  letter_reportsdate: this.filter.sdate,
                  letter_reportedate: this.filter.edate,
                  letter_reportcompany: this.filter.company,
                }
                let param 	   = this.$functions.ParamPOST(formdata)
                this.$axios.post(this.$functions.UrlPOST('apiWriteLetter'),param,{
                    headers: {
                        'Content-Type': 'text/plain; charset=ISO-8859-1'
                    }
                })
                .then(response => {
                    let feedback = response.data
                    if (feedback.length > 0) {
                        if(feedback[0].feedback === 'Y') {
                            window.open(feedback[0].feedback_url)
                        } else {
                            this.SnackBar(true, 'error', feedback[0].feedback, 3000)
                        }
                    } else {
                        this.SnackBar(true, 'error', this.$functions.ErrorCode(), 3000)
                    }
                    item.loading = false
                })
                .catch(e => {
                    this.SnackBar(true, 'error', e, 3000)
                    item.loading = false
                })
            },
            SnackBar (dialog, color, text, timeout) {
                this.snackbar = {
                    dialog: dialog,
                    color: color,
                    text: text,
                    timeout: timeout
                }
                if (color === 'error') {
                    this.filter.dialog 	 = false
                    this.filter.ok 	 	 = 'OK'
                }
            }
        }
    }
</script>